export const defaultKeyboardStep = 3;

function validateSlides(slides) {
  return slides.every((slide) => {
    return slide.beforeImage?.md && slide.afterImage?.md;
  });
}

function ctaValidation(value) {
  return value?.label && value?.url;
}

export const beforeAfterProps = {
  taggingId: {
    type: String,
    required: true,
  },
  title: {
    default: '',
    type: String,
  },
  titleHeadingLevel: {
    default: 'h2',
    type: String,
    validator(value) {
      return ['h1', 'h2', 'h3'].includes(value);
    },
  },
  subtitle: {
    default: '',
    type: String,
  },
  subtitleElement: {
    default: 'h3',
    type: String,
    validator(value) {
      return ['h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span'].includes(value);
    },
  },
  description: {
    default: '',
    type: String,
  },
  layout: {
    type: Object,
    required: false,
    default: () => ({
      position: 'top', // 'right', 'bottom', 'left'
      horizontalAlignment: 'left', // 'right', 'center'
      verticalAlignment: 'top', // 'middle', 'bottom'
    }),
  },
  moduleBackgroundColor: {
    type: String,
    default: 'transparent',
  },
  moduleCopyTextColor: {
    type: String,
    default: '#000',
  },
  beforeAfterCaptionColor: {
    type: String,
    default: '#000',
  },
  slides: {
    type: Array,
    required: true,
    validator: validateSlides,
  },
  thumbnailNavLabelNext: {
    type: String,
    default: 'Next',
  },
  thumbnailNavLabelPrev: {
    type: String,
    default: 'Previous',
  },
  thumbnailsWrapperLabel: {
    type: String,
    default: 'Select comparison view',
  },
  thumbnailsAccessibleLabel: {
    type: String,
    default: 'View {{value}} of',
  },
  cta: {
    type: Object,
    default: () => ({}),
    validator: ctaValidation,
  },
};

const ALLOWED_RESOLUTIONS = ['xs', 'sm', 'md', 'lg', 'xl'];
const ALLOWED_IMAGE_PROPERTIES = ['altText'];
const validateProperties = (value) => {
  if (!value?.md) return false;

  const ALLOWED_PROPERTIES = [...ALLOWED_RESOLUTIONS, ...ALLOWED_IMAGE_PROPERTIES];

  return Object.entries(value).every(
    ([resolution, src]) =>
      ALLOWED_PROPERTIES.includes(resolution) && src && typeof src === 'string',
  );
};
export const dynamicCompareProps = {
  // Image sources for using non-responsive BEFORE images
  beforeImage: {
    type: Object,
    required: true,
    validator: validateProperties,
  },
  // Text for the ALT tag of the built-in BEFORE image
  beforeImageAlt: {
    default: 'Before',
    type: String,
  },
  // Image sources for using non-responsive AFTER images
  afterImage: {
    type: Object,
    required: true,
    validator: validateProperties,
  },
  // Text for the ALT tag of the built-in AFTER image
  afterImageAlt: {
    default: 'After',
    type: String,
  },
};
export const compareProps = {
  // Text for the built-in BEFORE caption element
  beforeLabel: {
    default: 'Before',
    type: String,
  },
  // Text for the built-in AFTER caption element
  afterLabel: {
    default: 'After',
    type: String,
  },
  // Aria label for the separator's button element
  buttonAriaLabel: {
    default: undefined,
    type: String,
  },
  // TODO: addon feature, for the future, support vertical layouts
  direction: {
    default: 'horizontal',
    type: String,
  },
  // Permit native lazy loading of images of assets that are not LCP
  loading: {
    default: 'eager',
    type: String,
  },
  // Distance to move one a single keyboard arrow press
  keyboardStep: {
    default: defaultKeyboardStep,
    type: [Number, String],
  },
  // Initial position of the cursor
  initialPosition: {
    default: 50,
    type: Number,
  },
};
